import { CheckCircle } from 'lucide-react';
import { useJobContext } from 'pages/Job/context';

const QuoteChangesReceived: React.FunctionComponent = function () {
  const { companyName } = useJobContext();
  return (
    <div className="flex flex-row gap-x-2 p-3 md:p-4 bg-purple-50 border-2 border-purple-400 rounded-xl">
      <CheckCircle className="text-purple-400 min-w-6" size={24} />
      <div className="flex flex-col gap-y-1">
        <h1 className="text-16-24-em">Changes Received</h1>
        <h2 className="text-12-18-b md:text-14-22-b">
          Your quote has been updated by {companyName}. Please review the
          changes below
        </h2>
      </div>
    </div>
  );
};

export default QuoteChangesReceived;
